import { Box, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import {
    REALM_ADMIN,
    REALM_COMPTA,
    REALM_FORMALIST,
    REALM_INTERN,
    REALM_MADA,
    REALM_RESP_FORMALIST,
    UseKeycloakService,
} from '@europrocurement/l2d-keycloak';
import {
    dossiersBasePath,
    FormalistDashboard,
    FormalistManagerDashboard,
    InternDashboard,
} from '@europrocurement/l2d-modules';
import { useNavigate } from 'react-router';
import { Accordion, ReactGridContainerWithChildrens } from '@europrocurement/flexy-components';
import RelevesNonClotures from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/RelevesNonClotures';
import MesFacturesATraiter from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/MesFacturesATraiter';
import FacturesInternesNonAttribuees from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesInternesNonAttribuees';
import FacturesASynchroniser from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesASynchroniser';
import FacturesAvecErreursTechniques from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesAvecErreursTechniques';
import FacturesEnERDO5 from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesEnERDO5';
import FacturesATraiterManuellement from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesATraiterManuellement';
import FacturesEnPause from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesEnPause';
import FacturesATraiter from '../Accueil/WidgetsFrame/PortailAchatsWidgets/Widgets/FacturesATraiter';

const Dashboard = function () {
    const keycloakService = UseKeycloakService();
    // Roles
    const isAdmin = keycloakService.checkRole(REALM_ADMIN);
    const isCompta = keycloakService.checkRole(REALM_COMPTA);
    const isFormalist = keycloakService.checkRole(REALM_FORMALIST);
    const isRespFormalist = keycloakService.checkRole(REALM_RESP_FORMALIST);
    const isIntern = keycloakService.checkRole(REALM_INTERN);
    const isMada = keycloakService.checkRole(REALM_MADA);
    const isRespCompta = keycloakService.checkRole(REALM_COMPTA);

    const { idUserGie } = keycloakService.getTokenParsed();

    const currentUserName = keycloakService.getName();

    const navigate = useNavigate();
    const { palette } = useTheme();

    return (
        <Box>
            {isIntern && !isFormalist && !isCompta && idUserGie ? (
                <InternDashboard
                    title="Dashboard"
                    userId={parseInt(idUserGie, 10)}
                />
            ) : null}

            {isAdmin || isMada || isCompta || isRespCompta ? (
                <Accordion
                    title="Dashboard comptabilité"
                    expandLabel
                    expanded
                    expandColor={palette.secondary}
                    sx={{ boxShadow: 'unset', border: 'none' }}
                    contentSxProps={{ gap: '16px', display: 'grid' }}
                >
                    <ReactGridContainerWithChildrens
                        localStorageName="grid-compta-user"
                        showResetButton
                        childrens={[
                            {
                                key: 'list-widget-facture-a-traiter',
                                component: <FacturesATraiter />,
                            },
                            { key: 'list-widget-facture-en-pause', component: <FacturesEnPause /> },
                            ...(isIntern
                                ? [
                                      {
                                          key: 'list-widget-releve-non-cloture',
                                          component: <RelevesNonClotures />,
                                      },
                                      {
                                          key: 'list-widget-mes-facture-a-traiter',
                                          component: <MesFacturesATraiter />,
                                      },
                                      {
                                          key: 'list-widget-facture-non-attibuees',
                                          component: <FacturesInternesNonAttribuees />,
                                      },
                                  ]
                                : []),
                        ]}
                        cols={isIntern ? 5 : 2}
                    />

                    {isAdmin || isRespCompta ? (
                        <ReactGridContainerWithChildrens
                            localStorageName="grid-compta-user-admin"
                            showResetButton
                            childrens={[
                                {
                                    key: 'list-widget-facture-a-synchro',
                                    component: <FacturesASynchroniser />,
                                },
                                {
                                    key: 'list-widget-facture-erreur-technique',
                                    component: <FacturesAvecErreursTechniques />,
                                },
                                {
                                    key: 'list-widget-facture-er-dos5',
                                    component: <FacturesEnERDO5 />,
                                },
                                {
                                    key: 'list-widget-facture-traiter-manuellement',
                                    component: <FacturesATraiterManuellement />,
                                },
                            ]}
                            cols={isIntern ? 4 : 2}
                        />
                    ) : null}
                </Accordion>
            ) : null}

            {isFormalist &&
                (idUserGie ? (
                    <FormalistDashboard
                        formalistIds={[parseInt(idUserGie, 10)]}
                        listeDossiersPath={dossiersBasePath}
                        navigate={navigate}
                        title="Dashboard formaliste"
                        formalistName={currentUserName}
                    />
                ) : (
                    <Box>
                        <Typography>
                            Impossible d&apos;afficher le dashboard formaliste : identifiant
                            utilisateur non disponible.
                        </Typography>
                    </Box>
                ))}

            {isRespFormalist &&
                (idUserGie ? (
                    <FormalistManagerDashboard
                        formalistId={parseInt(idUserGie, 10)}
                        listeDossiersPath={dossiersBasePath}
                        navigate={navigate}
                        title="Dashboard responsable formaliste"
                        formalistName={currentUserName}
                    />
                ) : (
                    <Box>
                        <Typography>
                            Impossible d&apos;afficher le dashboard responsable formaliste :
                            identifiant utilisateur non disponible.
                        </Typography>
                    </Box>
                ))}
        </Box>
    );
};

export default Dashboard;
